import Cookies from 'js-cookie';
import axios from 'axios';

  // このモジュールが本来の検索機能に依存するのを避けるため、このモジュール内ではバナー自体の表示に関わるロジックしか実装していない。
  // バナーをクリックした時や検索条件にpcr_campaignの付加する実装は検索モジュールに移譲している

  // バナーのコンテナ
  const searchSuggestionBannerTag = () => document.querySelector('.m3p-fixedbnr-noflex');
  // バナーに表示するサジェスト画像
  const bannerImageTag = () =>  document.getElementById('suggest-banner-image');
  // バナーがクリックされたかを保存
  let bannerClicked = false;

  const noSuggestTypes = () => {
    if(Cookies.get().hasOwnProperty('no_suggest_types')){
      return Cookies.get().no_suggest_types.split(',');
    } else {
      return [];
    }
  }
  const setNoSuggestTypesToCookie = selectedSuggestType => {
    // バナーを一度消したら、1日間表示させない
    const no_suggest_types = noSuggestTypes();
    no_suggest_types.push(selectedSuggestType);
    Cookies.set('no_suggest_types', no_suggest_types.join(','), { expires: 1 });
  }

  // フッターの高さ制御
  const handleMovingTopButton = topBtnPosition => {
    const topBtn = document.querySelector('.m3p-pagetop');
    if (window.pageYOffset > 400) {
      topBtn.style.bottom = `${topBtnPosition}px`;
    } else {
      topBtn.style.bottom = `-${topBtnPosition}px`;
    }
  }
  const handleFooterHeight = () => {
    $(window).off('scroll', handleMovingTopButton);
    const bannerHeight = isDisplayableBanner() ? 80 : 0;

    const atlasFooterHeight = bannerHeight + 42;
    const atlasFooter = document.querySelector('.atlas-footer__bottom');
    // 画面表示時にatlasフッターの読み込みが完了していないため、atlasフッター読み込みした後にスタイル指定の処理を行うようにする
    if (atlasFooter !== null) {
      atlasFooter.style.height = `${atlasFooterHeight}px`;
    }
    const topBtnPosition = bannerHeight ;
    const topBtn = document.querySelector('.m3p-pagetop');
    topBtn.style.bottom = `${topBtnPosition}px`;

    handleMovingTopButton(topBtnPosition);
    $(window).on('scroll', () => handleMovingTopButton(topBtnPosition));
  }

  // バナー表示の制御
  const handleScrollEventForBanner = () => {
    if(searchSuggestionBannerTag()){
      searchSuggestionBannerTag().style.bottom = window.pageYOffset > 655 ? '0' : '-200px';
    }
  };
  export const closeBanner = () => {
    if(searchSuggestionBannerTag()){
      searchSuggestionBannerTag().style.bottom = '-200px';
      $(window).off('scroll', handleScrollEventForBanner);
      handleFooterHeight();
    }
  };

  // 各種バナーを表示(urlの中身、条件によって);
  // バナーに渡す情報を持つタグ
  // ajaxを経てタグが持つデータが切り替わっても毎回拾えるように関数として定義
  const bannerInformationContainedTag = () => document.getElementById('suggest-banner-information');
  const bannerInformation = () => bannerInformationContainedTag()
    ? JSON.parse(bannerInformationContainedTag().getAttribute('data'))
    : {
      suggest_types: [],
      banner_img_urls: [],
      pcr_campaign_values: [],
      is_logged_in: false,
      current_pickup: 0,
      pickup_id: 0
    };
  export const usableSuggestTypeIndex = () => bannerInformation().suggest_types.findIndex(suggestType => {
    if(suggestType === 'no_suggest') return false;
    return !noSuggestTypes().includes(suggestType);
  });
  const isDisplayableBanner = () => usableSuggestTypeIndex() >= 0;
  const bannerImageUrl = () => bannerInformation().banner_img_urls[usableSuggestTypeIndex()] || '';
  export const currentSuggestType = () => bannerInformation().suggest_types[usableSuggestTypeIndex()] || '';
  export const currentPickUp = () => bannerInformation().current_pickup || 0;
  export const PickUpId = () => bannerInformation().pickup_id || 0;
  export const currentLogIn = () => bannerInformation().is_logged_in || false;
  export const changeBannerImageTagSource = () => {
    if (bannerImageTag() && isDisplayableBanner()) {
      bannerImageTag().src = bannerImageUrl();
    } else if(bannerImageTag()) {
      bannerImageTag().src = '';
      searchSuggestionBannerTag().style.height = 0;
    }
    handleFooterHeight();
  };
  export const currentPcrCampaignValue = () => bannerInformation().pcr_campaign_values[usableSuggestTypeIndex()] || '';
  export const changeBannerClicked = status => bannerClicked = status;
  export const isBannerClicked = () => bannerClicked;
  export const refreshBannerEvents = () => {
    handleScrollEventForBanner();
    changeBannerImageTagSource();
    $(window).on('scroll', handleScrollEventForBanner);
    $(document).on('click', '.m3p-suggestpc-close-btn', e => {
      e.preventDefault();
      setNoSuggestTypesToCookie(currentSuggestType());
      closeBanner();
    });
    if(usableSuggestTypeIndex() < 0) closeBanner();
  }

  const PICKUP_API_BASE_PATH = (id) => `/positions/pickup/${id}`;
  export const patchPickup = async (id) => {
    const url = PICKUP_API_BASE_PATH(id);
    return await axios.patch(url, {})
        .then((response) => response.status)
        .catch((_) => {
          alert('ネットワークの状態が不安定です。\n通信回線の良い状況で再度接続してください');
        });
  };
  export const setPickup = async (id) => {
    const status = await patchPickup(id);
    if (status === 200) {
      const imageElement = document.getElementById('suggest-banner-image');
      let src = imageElement.src;
      if (src.includes('full_condition')) {
        src = src.replace(/[^/]+$/, 'already_mail_setting.png');
        imageElement.src = src;
        // 新着求人設定メールのバナーの表示条件をリロード時のURLと連動させる
        location.reload();
      }
      $.ajax({
        type: "PATCH",
        url: this.attr("href"),
        data: "",
        async: false
      });
    }
  }

  export const mailSettings = () => {
    $(document).on('click', '#suggest-banner-image-link', e => {
      if (currentLogIn() == true && currentPickUp() == 0) {
        setPickup(PickUpId());
      }
    });
  };
$(() => {
  mailSettings();
  refreshBannerEvents();
  handleFooterHeight();
});